<i18n>
{
  "en": {
    "ok": "OK"
  },
  "zh-tw": {
    "ok": "確定"
  }
}
</i18n>

<template>
  <f7-sheet style="height: 60%;">
    <f7-toolbar :color-theme="themeColor">
      <f7-link>{{ question.title }}</f7-link>
      <f7-link @click="$f7.sheet.close()">{{ $t(`ok`) }}</f7-link>
    </f7-toolbar>
    <f7-list style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: auto;">
      <f7-list-item
        v-for="(option, index) in question.options"
        :key="`checkbox-sheet-${index}`"
        no-hairlines
        no-hairlines-between
        :title="option.toString()">
        <f7-stepper
          :fill="!!question.value[option.id] || false"
          color="green"
          raised
          small
          round
          :min="0"
          :max="50"
          :step="1"
          :value="question.value[option.id]"
          @stepper:change="v => onChange(option.id, v)" />
      </f7-list-item>
    </f7-list>
  </f7-sheet>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'CheckboxSheetModal',
  dependencies: [
    'themeColor',
    'platformUtils',
    'CartElementBuilder'
  ],
  data () {
    return {
      itemDefinitionId: this.fullItemIdPathParam.split('.')[0],
      itemInstanceId: this.fullItemIdPathParam.split('.')[1]
    }
  },
  props: {
    itemBucketPathParam: String,
    fullItemIdPathParam: String,
    questionIdPathParam: String
  },
  computed: {
    ...mapState('itemModule', [
      'cart',
      'favorites'
    ]),
    ...mapGetters(['currentMenu']),
    itemObj () {
      return this[this.itemBucketPathParam][this.itemDefinitionId][this.itemInstanceId]
    },
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionIdPathParam, this.itemObj, this.currentMenu)
    }
  },
  methods: {
    onChange (optionId, v) {
      const value = Object.assign({}, this.question.value)
      if (v === 0) {
        delete value[optionId]
      } else {
        value[optionId] = v
      }
      this.setQuestion({
        itemBucket: this.itemBucketPathParam,
        itemId: this.itemDefinitionId,
        itemInstanceId: this.itemInstanceId,
        questionId: this.questionIdPathParam,
        value
      })
    },
    ...mapActions('itemModule', ['setQuestion'])
  }
}
</script>

<style lang="scss" scoped>
</style>
